import React, { ReactChild, ReactChildren } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import styled from 'styled-components'
import DropdownToggle from './DropdownToggle'
import { itemStyle } from './styles'

interface NavDropdownProps {
    id: string
    text: string
    icon?: string
    children: ReactChildren | ReactChild | ReactChild[]
    ToggleComponent?: typeof DropdownToggle
}

export const S = {
    DropdownMenu: styled(Dropdown.Menu)`
        border: none;
        border-radius: 0;
    `
}

const NavDropdown = ({
    children, text, ToggleComponent = DropdownToggle,
}: NavDropdownProps) => (
    <Dropdown style={itemStyle}>
        <Dropdown.Toggle
            as={ToggleComponent}
            text={text}
        />

        <S.DropdownMenu>
            {children}
        </S.DropdownMenu>
    </Dropdown>
)

export default NavDropdown
